import React from 'react';
import { Routes, Route, Navigate, useNavigate, useParams } from 'react-router-dom';
import { Layout } from './components/Layout';
import { Dashboard } from './pages/Dashboard';
import { InvestigationWorkbench } from './pages/InvestigationWorkbench';
import { InvestigationWorkbenchHumanReview } from './pages/InvestigationWorkbenchHumanReview';
import { Outbox } from './pages/Outbox';
import { Ledger } from './pages/Ledger';
import { FrictionQueue } from './pages/FrictionQueue';
import { Checks } from './pages/Checks';
import { CheckDetail } from './pages/CheckDetail';
import { Integrations } from './pages/Integrations';
import { Rules } from './pages/Rules';
import { allChecks } from './data/checks';
import { NavTemp } from './pages/NavTemp';
function CheckDetailRoute() {
  const {
    id
  } = useParams<{
    id: string;
  }>();
  const navigate = useNavigate();
  const check = allChecks.find(c => c.id === Number(id));
  if (!check) return <Navigate to="/checks" replace data-id="element-0" />;
  return <CheckDetail check={check} onBack={() => navigate('/checks')} onNavigate={page => {
    // Handle pages with query params (e.g. 'outbox?expand=2')
    const [pageName, queryString] = page.split('?');
    const path = `/${pageName.replace('settings-', 'settings/')}`;
    navigate(queryString ? `${path}?${queryString}` : path);
  }} data-id="element-1" />;
}
function WorkbenchRoute() {
  const navigate = useNavigate();
  return <InvestigationWorkbench onNavigate={page => navigate(`/${page.replace('settings-', 'settings/')}`)} onBackToCheck={() => navigate('/checks/2')} data-id="element-2" />;
}
function WorkbenchReviewRoute() {
  const navigate = useNavigate();
  return <InvestigationWorkbenchHumanReview onNavigate={page => navigate(`/${page.replace('settings-', 'settings/')}`)} onBackToCheck={() => navigate('/checks/2')} data-id="element-3" />;
}
function DashboardRoute() {
  const navigate = useNavigate();
  return <Dashboard onNavigate={page => navigate(`/${page.replace('settings-', 'settings/')}`)} data-id="element-4" />;
}
export function App() {
  return <Layout data-id="element-5">
      <Routes data-id="element-6">
        <Route path="/" element={<Navigate to="/dashboard" replace data-id="element-8" />} data-id="element-7" />
        <Route path="/dashboard" element={<DashboardRoute data-id="element-10" />} data-id="element-9" />
        <Route path="/checks" element={<Checks data-id="element-12" />} data-id="element-11" />
        <Route path="/checks/:id" element={<CheckDetailRoute data-id="element-14" />} data-id="element-13" />
        <Route path="/workbench" element={<WorkbenchRoute data-id="element-16" />} data-id="element-15" />
        <Route path="/workbench-review" element={<WorkbenchReviewRoute data-id="element-18" />} data-id="element-17" />
        <Route path="/outbox" element={<Outbox data-id="element-20" />} data-id="element-19" />
        <Route path="/ledger" element={<Ledger data-id="element-22" />} data-id="element-21" />
        <Route path="/friction" element={<FrictionQueue data-id="element-24" />} data-id="element-23" />
        <Route path="/settings/integrations" element={<Integrations data-id="element-26" />} data-id="element-25" />
        <Route path="/settings/rules" element={<Rules data-id="element-28" />} data-id="element-27" />
        <Route path="/nav" element={<NavTemp data-id="element-30" />} data-id="element-29" />
        <Route path="*" element={<Navigate to="/dashboard" replace data-id="element-32" />} data-id="element-31" />
      </Routes>
    </Layout>;
}